import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import { Stack, Box, Typography } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import '../style/legend_risk.css';
import TreemapShelterAnalysis from '../components/treemap_shelter_analysis';
import MapShelterAnalysis from '../components/map_shelter_analysis';
import VerticalBar from '../components/vertical_bar'
import Line from '../components/line_shelter_analysis';
import VerticalBarShelterAnalysis from '../components/vertical_bar_shelter_analysis';
import { GRID_RANK } from '../const/grid'
import { SHELTER_ANARYSIS_HDCNT_LEGEND, TREND_PIVOT_VERTICAL_BAR_STACK_LEGEND } from '../const/legend'
import ThreeDayShelterTxt from '../item/three_day_shelter_txt';
import CommonCard from '../item/common_card';
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
import { setEvacColor, setShelterAnalysisColor } from '../func/color';
import {
    getTimeAry,
    getShelterAnalysisList, getCityCodeByShelterCode, getShelterCodeByCityCode, getAllByShelterCode, getKeyNameList, getShelterDateTime, getShelterAnalysisRankWithLimit, getAllByCityCode, getEvacRankWithLimit, getEvacDateData, getDateData,
    getNeedInspectionList,
    getShelterAnalysisRankData
} from '../func/util'
import choropleth_msh from '../data/msh.json';
import choropleth_city from '../data/city.json';

const ShelterAnalysis = (props) => {
    const [dateArray, setDateArray] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    // 避難所分析
    const [shelterAnalysisData, setShelterAnalysisData] = useState(null);
    const [evacLevelCityData, setEvacLevelCityData] = useState(null);
    const [closeData, setCloseData] = useState(null);
    const [openData, setOpenData] = useState(null);
    const [shelterAnalysisTreeMapData, setShelterAnalysisTreeMapData] = useState(null);
    const [lastReportedRankData, setLastReportedRankData] = useState([]);
    const [hdcntMaxRankData, setHdcntMaxRankData] = useState([]);
    const [hdcntLagRankData, setHdcntLagRankData] = useState([]);
    const [lineDateArray, setLineDateArray] = useState(null);
    const [trendEvacCategories, setTrendEvacCategories] = useState(null);
    const [trendEvacData, setTrendEvacData] = useState(null);
    const [trendShelter, setTrendShelter] = useState(null);
    const [shelterNeedInspectionData, setShelterNeedInspectionData] = useState(null);
    const [shelterAnalysisTrendPivot, setShelterAnalysisTrendPivot] = useState(null);

    const location = useLocation();
    const prevDatetimeRef = useRef(null);

    // 全データ再取得の要否を定期監視する
    const {
        data: datetimeLatest,
        loading: datetimeLatestLoading,
        error: datetimeLatestError,
    } = useDataFromS3(`api/get_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (datetimeLatest && JSON.stringify(datetimeLatest) !== JSON.stringify(prevDatetimeRef.current)) {
            prevDatetimeRef.current = datetimeLatest;
            setShouldFetch(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetch(false); // dataが変わってないならメインデータを取得しない
        }
    }, [datetimeLatest]);

    let shelter_url = null
    let shelter_evac_level_city_url = null
    let shelter_date_url = null
    let get_geonavi_events_latest_by_building_url = null
    let get_5th_infection_trend_pivot_url = null

    if (shouldFetch) {
        shelter_url = `api/get_shelter_analysis_dtl`
        shelter_evac_level_city_url = `api/get_shelter_analysis_evac_level_city`
        shelter_date_url = `api/get_shelter_analysis_timeline`
        get_geonavi_events_latest_by_building_url = `api/get_geonavi_events_latest_by_building`
        get_5th_infection_trend_pivot_url = `api/get_5th_infection_trend_pivot`
    }

    // reload page when change pathname
    useEffect(() => {
        prevDatetimeRef.current = null
    }, [location.pathname])

    // 避難所分析データを取得
    const {
        data: shelterData,
        loading: shelterLoading,
        error: shelterError,
    } = useDataFromS3(shelter_url);

    // 避難所分析の避難指示発令地域データを取得
    const {
        data: shelterEvacLevelCityData,
        loading: shelterEvacLevelCityLoading,
        error: shelterEvacLevelCityError,
    } = useDataFromS3(shelter_evac_level_city_url);

    // 避難所分析の日時データを取得
    const {
        data: shelterDateData,
        loading: shelterDateLoading,
        error: shelterDateError,
    } = useDataFromS3(shelter_date_url);

    const {
        data: geonaviEventsLatestByBuildingData,
        loading: geonaviEventsLatestByBuildingLoading,
        error: geonaviEventsLatestByBuildingError
    } = useDataFromS3(get_geonavi_events_latest_by_building_url);

    const {
        data: infectionTrendPivotData,
        loading: infectionTrendPivotLoading,
        error: infectionTrendPivotError
    } = useDataFromS3(get_5th_infection_trend_pivot_url);

    // ツリーマップクリック時の動作
    const clickHandler = (code_ary) => {
        // ローディング開始
        startLoading()

        props.setSelectSubCity(code_ary);
        props.setSelectShelterCode([])
    }

    // ランキングデータ取得
    const getLastReportedRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.last_reported_diff !== b.last_reported_diff) {
                    return a.last_reported_diff - b.last_reported_diff;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.last_reported_diff !== b.last_reported_diff) {
                    return b.last_reported_diff - a.last_reported_diff;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].last_reported_diff,
                        custom: {
                            code: rankData[i].code,
                            city_code: rankData[i].city_code,
                            city_name: rankData[i].txt_city_name,
                            area_name: rankData[i].txt_area_name,
                            area_lng: rankData[i].dc_lng_num,
                            area_lat: rankData[i].dc_lat_num,
                            last_reported_diff: rankData[i].last_reported_diff
                        }
                    })
                    category_ary.push(rankData[i].txt_area_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: Number(item.last_reported_diff) || 0,
                    custom: {
                        code: item.code,
                        city_code: item.city_code,
                        city_name: item.txt_city_name,
                        area_name: item.txt_area_name,
                        area_lng: item.dc_lng_num,
                        area_lat: item.dc_lat_num,
                        last_reported_diff: item.last_reported_diff
                    }
                })
                category_ary.push(String(item.txt_area_name || ''));
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングデータ取得
    const getHdcntMaxRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.int_hdcnt_num_diff_max !== b.int_hdcnt_num_diff_max) {
                    return a.int_hdcnt_num_diff_max - b.int_hdcnt_num_diff_max;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.int_hdcnt_num_diff_max !== b.int_hdcnt_num_diff_max) {
                    return b.int_hdcnt_num_diff_max - a.int_hdcnt_num_diff_max;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].int_hdcnt_num_diff_max,
                        custom: {
                            code: rankData[i].code,
                            city_code: rankData[i].city_code,
                            city_name: rankData[i].txt_city_name,
                            area_name: rankData[i].txt_area_name,
                            area_lng: rankData[i].dc_lng_num,
                            area_lat: rankData[i].dc_lat_num,
                            int_hdcnt_num_diff_max: rankData[i].int_hdcnt_num_diff_max
                        }
                    })
                    category_ary.push(rankData[i].txt_area_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: Number(item.int_hdcnt_num_diff_max) || 0,
                    custom: {
                        code: item.code,
                        city_code: item.city_code,
                        city_name: item.txt_city_name,
                        area_name: item.txt_area_name,
                        area_lng: item.dc_lng_num,
                        area_lat: item.dc_lat_num,
                        int_hdcnt_num_diff_max: item.int_hdcnt_num_diff_max
                    }
                })
                category_ary.push(String(item.txt_area_name || ''));
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングデータ取得
    const getHdcntLagRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.int_hdcnt_num_diff_lag !== b.int_hdcnt_num_diff_lag) {
                    return a.int_hdcnt_num_diff_lag - b.int_hdcnt_num_diff_lag;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.int_hdcnt_num_diff_lag !== b.int_hdcnt_num_diff_lag) {
                    return b.int_hdcnt_num_diff_lag - a.int_hdcnt_num_diff_lag;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].int_hdcnt_num_diff_lag,
                        custom: {
                            code: rankData[i].code,
                            city_code: rankData[i].city_code,
                            city_name: rankData[i].txt_city_name,
                            area_name: rankData[i].txt_area_name,
                            area_lng: rankData[i].dc_lng_num,
                            area_lat: rankData[i].dc_lat_num,
                            int_hdcnt_num_diff_lag: rankData[i].int_hdcnt_num_diff_lag
                        }
                    })
                    category_ary.push(rankData[i].txt_area_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: Number(item.int_hdcnt_num_diff_lag) || 0,
                    custom: {
                        code: item.code,
                        city_code: item.city_code,
                        city_name: item.txt_city_name,
                        area_name: item.txt_area_name,
                        area_lng: item.dc_lng_num,
                        area_lat: item.dc_lat_num,
                        int_hdcnt_num_diff_lag: item.int_hdcnt_num_diff_lag
                    }
                })
                category_ary.push(String(item.txt_area_name || ''));
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        props.setSelectSubCity([]);
        props.setSelectShelterCode([clickedItem.custom.code])
    }

    // ランキングのカラー（報告がない避難所一覧）
    const getRankLastReportedColor = (value, series, seriesIndex, dataPointIndex) => {
        return "#5899da"
    }

    // ランキングのカラー（報告がない避難所一覧）
    const getRankHdcntMaxOrLagColor = (value, series, seriesIndex, dataPointIndex) => {
        const num = Number(value);
        if (!isFinite(num)) return '#77d36f';
        return num < 0 ? '#e78c07' : '#77d36f';
    }

    const toZenkakuAll = (str) => {
        return str
            .replace(/[0-9A-Za-z]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0)) // 半角英数字 → 全角
            .replace(/,/g, '、')         // 半角カンマ → 全角カンマ
            .replace(/ /g, '　')         // 半角スペース → 全角スペース
            .replace(/\(/g, '（')        // 半角( → 全角（
            .replace(/\)/g, '）');       // 半角) → 全角）
    };

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        const str = toZenkakuAll(String(value));
        // 8文字以上は省略
        if (str.length >= 8) {
            return str = str.slice(0, 3) + '…' + str.slice(-4);
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return '';
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts) => {
        const seriesIndex = opts.seriesIndex;
        const dataPointIndex = opts.dataPointIndex;
        const dataPoint = opts.w?.config?.series?.[seriesIndex]?.data?.[dataPointIndex] || {};
        const value = dataPoint.y ?? opts.series?.[seriesIndex]?.[dataPointIndex] ?? '';
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];
        // 優先して custom.area_name（getRankData で設定しているフィールド）を表示
        const areaName = dataPoint.custom?.area_name || seriesName || '';

        return `<div style="padding: 6px 8px; font-size: 12px;">
            <div>${areaName}: ${value}</div>
        </div>`;
    };

    // データ整備用のパラメータを取得
    const getParams = (keyAry, keyName = '') => {
        const features_city = choropleth_city.features;

        let selectShelterFlg = false
        let shelter_code_ary = []

        if (keyName === 'shelter_code') {
            shelter_code_ary = props.selectShelterCode;
            selectShelterFlg = true
        }

        // --- city 用の配列とフィーチャーを作成 ---
        let city_code_ary = [];
        let masterCityFeatures = [];

        if (keyName === 'city_code') {
            // 指定された city_code を元に市町村ポリゴン（features_city から）を取得
            const targetCitySet = new Set(
                (keyAry || []).map(k => Number(k)).filter(n => !isNaN(n))
            );

            masterCityFeatures = features_city.filter(feature => {
                const raw = feature.properties.id;
                if (Array.isArray(raw)) {
                    return raw.some(r => targetCitySet.has(Number(r)));
                }
                return targetCitySet.has(Number(raw));
            });

            city_code_ary = masterCityFeatures
                .map(f => Number(f.properties.id))
                .filter((v, i, a) => !isNaN(v) && a.indexOf(v) === i);
            shelter_code_ary = getShelterCodeByCityCode(shelterData, city_code_ary);

        } else {
            city_code_ary = getCityCodeByShelterCode(shelterData, shelter_code_ary);
        }
        return {
            city_code_ary,
            masterCityFeatures,
            shelter_code_ary
        };
    }

     // ランキングのカラー（土砂）
    const getRankColor = (value, series, seriesIndex, dataPointIndex) => {
        return setShelterAnalysisColor(series[seriesIndex].name)
    }

    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        if (!Array.isArray(data) || data.length === 0) return { rankData: [], series_ary: [], category_ary: [] };
        let rankData = data;
        rankData.sort((a, b) => {
            if (a.total !== b.total) {
                return isOver ? a.total - b.total : b.total - a.total;
            }
            return String(a.code).localeCompare(String(b.code));
        });

        // sliderValueに応じてリスクの最大値を並べ替え
        const series_ary = [];
        const category_ary = [];
        const start = sliderValueRef.current[0];
        const end = sliderValueRef.current[1];
        const slicedData = rankData.slice(start, end + 1);

        slicedData.forEach(item => {
            series_ary.push({
                x: '',
                y: item.total,
                custom: {
                    area: item.area,
                    code: item.code,
                    total: item.total
                }
            });

            category_ary.push(item.area);
        });

        return {
            rankData,
            series_ary,
            category_ary
        };
    }

    // ローディング開始
    const startLoading = () => {
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
    }

    useEffect(() => {
        // ローディング開始
        startLoading()
        const fetchData = async () => {
            let params_obj = {}
            let date_ary = []

            let city_shelter_all_datetime = []
            let city_evac_level_data_all_datetime = []
            let city_shelter_date_data_all_datetime = []
            let shelter_analysis_map_data = []
            let shelter_analysis_close_data = []
            let shelter_analysis_open_data = []
            let shelter_analysis_evac_rank = []
            let shelter_analysis_evac_treemap = []
            let last_reported_data = []
            let hdcnt_max_data = []
            let hdcnt_lag_data = []
            let shelter_date_time = []
            let evac_date_data = []
            let shelter_date_data = []
            let shelter_need_inpection_data = [];
            let shelter_analysis_trend_pivot = [];
            let flagShowBuilding = true;
            if (props.selectMsh && Array.isArray(props.selectMsh)
                && props.selectMsh.length > 0) {
                params_obj = getParams(props.selectMsh, 'id')
                flagShowBuilding = false;
                
            } else if (props.selectSubCity && Array.isArray(props.selectSubCity)
                && props.selectSubCity.length > 0) {
                params_obj = getParams(props.selectSubCity, 'city_code')
                flagShowBuilding = false;
                
            } else if (props.selectShelterCode && Array.isArray(props.selectShelterCode)
                && props.selectShelterCode.length > 0) {
                params_obj = getParams(props.selectShelterCode, 'shelter_code')
                flagShowBuilding = false;
            } else {
                params_obj = getParams(props.selectCitys, 'city_code')
            }
            
            let shelter_events_latest_by_building = (flagShowBuilding && props.selectCitys.length > 0) ? geonaviEventsLatestByBuildingData : [];
            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(datetimeLatest, props.h6Switch)

                // 市町村コードごとの避難所分析のオブジェクト配列を取得
                // [{ city_code: 38203（市町村コード）, 
                city_shelter_all_datetime = getAllByShelterCode(params_obj.shelter_code_ary, shelterData)
                city_evac_level_data_all_datetime = getAllByCityCode(params_obj.city_code_ary, shelterEvacLevelCityData, false)
                city_shelter_date_data_all_datetime = getAllByShelterCode(params_obj.shelter_code_ary, shelterDateData, false)
                // 点検が必要な避難所用データ
                shelter_need_inpection_data = getNeedInspectionList(shelter_events_latest_by_building);
                // 感染症流行状況用データ
                shelter_analysis_trend_pivot = getShelterAnalysisRankData(infectionTrendPivotData);

                if (city_shelter_all_datetime.length > 0 && city_shelter_date_data_all_datetime.length > 0 && city_evac_level_data_all_datetime.length > 0) {
                    // マップの避難所用データ
                    shelter_analysis_map_data = getShelterAnalysisList(city_shelter_all_datetime);
                    // 3日間で閉鎖された避難所用のデータ
                    shelter_analysis_close_data = getKeyNameList(city_shelter_all_datetime, '閉鎖');
                    // 3日間で開設された避難所用のデータ
                    shelter_analysis_open_data = getKeyNameList(city_shelter_all_datetime, '開設');

                    // 市町村別避難者数スコアリング用のデータ
                    shelter_analysis_evac_rank = getEvacRankWithLimit(city_shelter_all_datetime, 200);
                    shelter_analysis_evac_treemap = shelter_analysis_evac_rank.slice(0, 20);
                    // 報告がない避難所一覧用のデータ
                    last_reported_data = getShelterAnalysisRankWithLimit(city_shelter_all_datetime, 200, 'last_reported_diff');
                    // 急激な避難者数増減があった避難所（ピーク時差）用のデータ
                    hdcnt_max_data = getShelterAnalysisRankWithLimit(city_shelter_all_datetime, 200, 'int_hdcnt_num_diff_max');
                    // 急激な頻社数増減があった避難所（前日差）用のデータ
                    let hdcnt_lag = getShelterAnalysisRankWithLimit(city_shelter_all_datetime, 200, 'int_hdcnt_num_diff_lag');
                    hdcnt_lag_data = hdcnt_lag.filter(item => item.int_hdcnt_num_diff_lag !== 0);
                    // 避難者推移、避難所推移用の日時配列データ
                    shelter_date_time = getShelterDateTime(city_shelter_date_data_all_datetime)
                    // 避難者推移用のデータ
                    evac_date_data = getEvacDateData(city_shelter_date_data_all_datetime, shelter_date_time)
                    // 避難所推移用のデータ
                    shelter_date_data = getDateData(city_shelter_date_data_all_datetime, shelter_date_time)
                }
            }

            // 避難所分析データ
            setShelterAnalysisData(shelter_analysis_map_data.length > 0 ? shelter_analysis_map_data : null)
            // 避難指示発令地域データ
            setEvacLevelCityData(city_evac_level_data_all_datetime.length > 0 ? city_evac_level_data_all_datetime : null)
            // 3日間で閉鎖された避難所
            setCloseData(shelter_analysis_close_data)
            // 3日間で開設された避難所
            setOpenData(shelter_analysis_open_data)
            // 点検が必要な避難所
            setShelterNeedInspectionData(shelter_need_inpection_data)
            // 市町村別避難者数スコアリング
            setShelterAnalysisTreeMapData(shelter_analysis_evac_treemap.length > 0 ? shelter_analysis_evac_treemap : null)
            // 報告がない避難所一覧
            setLastReportedRankData(last_reported_data.length > 0 ? last_reported_data : [])
            // 急激な避難者数増減があった避難所（ピーク時差）
            setHdcntMaxRankData(hdcnt_max_data.length > 0 ? hdcnt_max_data : [])
            // 急激な頻社数増減があった避難所（前日差）
            setHdcntLagRankData(hdcnt_lag_data.length > 0 ? hdcnt_lag_data : [])
            // 折れ線グラフ用の日時配列
            setLineDateArray(shelter_date_time.length > 0 ? shelter_date_time : null)
            // 避難者数推移
            setTrendEvacCategories(evac_date_data.categories)
            setTrendEvacData(evac_date_data.data)
            // 避難所数推移
            setTrendShelter(shelter_date_data)
            // 感染症流行状況
            setShelterAnalysisTrendPivot(shelter_analysis_trend_pivot.length > 0 ? shelter_analysis_trend_pivot : null)

            // 日時
            setDateArray(date_ary.length > 0 ? date_ary : null)
        };
        if (datetimeLatest
            && shelterData
            && shelterEvacLevelCityData
            && geonaviEventsLatestByBuildingData
            && infectionTrendPivotData
            && shelterDateData) {
            fetchData();
        }
    }, [datetimeLatest,
        shelterData, shelterEvacLevelCityData, shelterDateData, geonaviEventsLatestByBuildingData, infectionTrendPivotData,
        props.selectCitys, props.selectSubCity, props.selectMsh, props.selectShelterCode,
        props.h6Switch
    ]);

    if (datetimeLatestLoading || datetimeLatest === undefined
        || (datetimeLatestError && datetimeLatestError.message.includes("Received HTML"))
        || shelterLoading || shelterData === undefined
        || (shelterError && shelterError.message.includes("Received HTML"))
        || shelterEvacLevelCityLoading || shelterEvacLevelCityData === undefined
        || (shelterEvacLevelCityError && shelterEvacLevelCityError.message.includes("Received HTML"))
        || shelterDateLoading || shelterDateData === undefined
        || (shelterDateError && shelterDateError.message.includes("Received HTML"))
        || geonaviEventsLatestByBuildingLoading || geonaviEventsLatestByBuildingData === undefined
        || (geonaviEventsLatestByBuildingError && geonaviEventsLatestByBuildingError.message.includes("Received HTML"))
        || infectionTrendPivotLoading || infectionTrendPivotData === undefined
        || (infectionTrendPivotError && infectionTrendPivotError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (datetimeLatestError
        || shelterError
        || shelterEvacLevelCityError
        || shelterDateError
        || geonaviEventsLatestByBuildingError
        || infectionTrendPivotError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    // グローバルヘッダーの「36px」と時刻表示分の「17px」、大枠のGridのマージン上下「8px」ずつを差し引きく
                    height: { xs: '100%', sm: 'calc(100dvh - 36px - 17px - 8px - 8px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={datetimeLatest[12]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%
                >
                    <Grid container size={{ xs: 12, sm: 12, md: 5 }} direction="column">
                        <Grid container
                            
                        >
                            {/* マップ */}
                            <CommonCard
                                child={
                                    <MapShelterAnalysis
                                        selectCitys={props.selectCitys}
                                        setSelectSubCity={props.setSelectSubCity}
                                        setSelectShelterCode={props.setSelectShelterCode}
                                        riskMapZoom={props.riskMapZoom}
                                        riskMapCenter={props.riskMapCenter}
                                        shelterList={shelterAnalysisData}
                                        shelterEvacLevelCityList={evacLevelCityData}
                                        shelterNeedInspectionList={shelterNeedInspectionData}
                                    />
                                }
                                title={"避難所と避難指示発令地域"}
                                xsHeight="300px"
                                height='calc(70dvh - (36px * 0.7) - (17px * 0.7) - (8px * 0.7) - (8px * 0.7) - 31px - 5px)'
                            />
                        </Grid>
                        <Grid container
                            
                        >
                            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                <Stack spacing={0}>
                                    {/* テキスト */}
                                    <ThreeDayShelterTxt
                                        title={"3日間で閉鎖された避難所"}
                                        shelterVal={closeData}
                                        xsHeight="150px"
                                        height={'calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'}
                                    />
                                </Stack>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                <Stack spacing={0}>
                                    {/* テキスト */}
                                    <ThreeDayShelterTxt
                                        title={"3日間で開設された避難所"}
                                        shelterVal={openData}
                                        xsHeight="150px"
                                        height={'calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 7 }}>
                        <Grid container
                            spacing={0}
                            columns={12}
                            sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%
                        >
                            <Grid size={{ xs: 12, sm: 12, md: 8 }} >
                                <Grid size={{ xs: 12, sm: 12, md: 12 }} direction="column">
                                    {/* 折れ線 */}
                                    <CommonCard
                                        child={
                                            <Line
                                                limitVal={200}
                                                dateArray={trendEvacCategories}
                                                chartData={trendEvacData}
                                                isReadyKey={['line_trend_evac']}
                                                isReadyFlg={props.isReady.line_trend_evac}
                                                setReady={props.setReady}
                                                dataName={"避難者数"}
                                                unit={"人"}
                                            />
                                        }
                                        title={"避難者推移"}
                                        xsHeight="150px"
                                        height='calc(20dvh - (36px * 0.2) - (17px * 0.2) - (8px * 0.2) - (8px * 0.2) - 31px - 5px)'
                                    />
                                    {/* 折れ線 */}
                                    <CommonCard
                                        child={
                                            <Line
                                                limitVal={100}
                                                dateArray={lineDateArray}
                                                chartData={trendShelter}
                                                isReadyKey={['line_trend_shelter']}
                                                isReadyFlg={props.isReady.line_trend_shelter}
                                                setReady={props.setReady}
                                                dataName={"避難所数"}
                                                unit={"件"}
                                            />
                                        }
                                        title={"避難所推移"}
                                        xsHeight="150px"
                                        height='calc(20dvh - (36px * 0.2) - (17px * 0.2) - (8px * 0.2) - (8px * 0.2) - 31px - 5px)'
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                                <CommonCard
                                    child={
                                        <>
                                            {TREND_PIVOT_VERTICAL_BAR_STACK_LEGEND()}
                                            <VerticalBarShelterAnalysis
                                                distance={100}
                                                limitVal={0}
                                                grid={GRID_RANK}
                                                allRankData={shelterAnalysisTrendPivot}
                                                dateArray={dateArray}
                                                getRankData={getRankData}
                                                plusValue={1}
                                                getRankColor={getRankColor}
                                                fontSize={'12px'}
                                                maxWidth={100}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'calc(100% - 15px)'}
                                                isReadyKey={['vertical_bar_shelter_analysis']}
                                                isReadyFlg={props.isReady.vertical_bar_shelter_analysis}
                                                setReady={props.setReady}
                                            />
                                        </>
                                    }
                                    title={"感染症流行状況"}
                                    xsHeight="300px"
                                    height='calc(40dvh - (36px * 0.4) - (17px * 0.4) - (8px * 0.4) - (8px * 0.4) - 31px - 5px)'
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                                <Stack spacing={0}>
                                    {/* ツリーマップ */}
                                    <CommonCard
                                        child={
                                            <TreemapShelterAnalysis
                                                treemapData={shelterAnalysisTreeMapData}
                                                dateArray={dateArray}
                                                clickHandler={clickHandler}
                                                setColor={setEvacColor}
                                                isReadyKey={['treemap_shelter_analysis']}
                                                isReadyFlg={props.isReady.treemap_shelter_analysis}
                                                setReady={props.setReady}
                                            />
                                        }
                                        title={"市町村別避難者数スコアリング"}
                                        xsHeight="200px"
                                        height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'
                                    />
                                    {/* ランキング */}
                                    <CommonCard
                                        child={
                                            <VerticalBar
                                                distance={10}
                                                limitVal={1000}
                                                grid={GRID_RANK}
                                                allRankData={lastReportedRankData}
                                                dateArray={dateArray}
                                                getRankData={getLastReportedRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRankLastReportedColor}
                                                fontSize={'12px'}
                                                maxWidth={180}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'calc(100% - 0px)'}
                                                isReadyKey={['rank_last_reported']}
                                                isReadyFlg={props.isReady.rank_last_reported}
                                                setReady={props.setReady}
                                            />
                                        }
                                        title={"報告がない避難所一覧"}
                                        xsHeight="200px"
                                        height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'
                                    />
                                </Stack>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                                {/* ランキング */}
                                <CommonCard
                                    child={
                                        <>
                                            {SHELTER_ANARYSIS_HDCNT_LEGEND()}
                                            <VerticalBar
                                                distance={10}
                                                limitVal={1000}
                                                grid={GRID_RANK}
                                                allRankData={hdcntLagRankData}
                                                dateArray={dateArray}
                                                getRankData={getHdcntLagRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRankHdcntMaxOrLagColor}
                                                fontSize={'12px'}
                                                maxWidth={180}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'calc(100% - 10px)'}
                                                isReadyKey={['rank_hdcnt_lag']}
                                                isReadyFlg={props.isReady.rank_hdcnt_lag}
                                                setReady={props.setReady}
                                            />
                                        </>
                                    }
                                    title={"急激な避難者数増減があった避難所（前日差）"}
                                    xsHeight="350px"
                                    height='calc(60dvh - (36px * 0.6) - (17px * 0.6) - (8px * 0.6) - (8px * 0.6) - 31px - 5px)'
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                                <Stack spacing={0}>
                                    <ThreeDayShelterTxt
                                        title={"点検が必要な避難所"}
                                        shelterVal={shelterNeedInspectionData}
                                        xsHeight="150px"
                                        height={'calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'}
                                    />
                                    <CommonCard
                                        child={
                                            <>
                                                {SHELTER_ANARYSIS_HDCNT_LEGEND()}
                                                <VerticalBar
                                                    distance={10}
                                                    limitVal={1000}
                                                    grid={GRID_RANK}
                                                    allRankData={hdcntMaxRankData}
                                                    dateArray={dateArray}
                                                    getRankData={getHdcntMaxRankData}
                                                    plusValue={10}
                                                    verticalBarClickEvent={verticalBarClickEvent}
                                                    getRankColor={getRankHdcntMaxOrLagColor}
                                                    fontSize={'12px'}
                                                    maxWidth={180}
                                                    getLabelFormat={getLabelFormat}
                                                    enabled={true}
                                                    tooltipFormatX={tooltipFormatX}
                                                    tooltipFormatY={tooltipFormatY}
                                                    tooltipFormatCustom={tooltipFormatCustom}
                                                    height={'calc(100% - 10px)'}
                                                    isReadyKey={['rank_hdcnt_max']}
                                                    isReadyFlg={props.isReady.rank_hdcnt_max}
                                                    setReady={props.setReady}
                                                />
                                            </>
                                        }
                                        title={"急激な避難者数増減があった避難所（ピーク時差）"}
                                        xsHeight="350px"
                                        height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - 31px - 5px)'
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}
export default ShelterAnalysis;